exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".operate[data-v-6a1ac2c6] {\n  color: #1890ff;\n  font-size: 14px;\n  margin: 0 20px;\n  cursor: pointer;\n}\n", ""]);

// exports
